/*
 * @Author: codesides
 * @Descripttion:
 * @Date: 2022-05-06 17:56:52
 * @LastEditors: codesides
 * @LastEditTime: 2026-03-17 10:05:24
 * @FilePath: \lesson-web-cms\src\main.ts
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import ElementPlus from 'element-plus'

import 'ant-design-vue/dist/antd.less'
import 'element-plus/dist/index.css'
import './assets/css/reset.less'
import './assets/css/public.less'
import './assets/css/custom.scss' // 机构、师资临时公共样式
import './assets/css/main.css'
// import "vue3-video-play/dist/style.css"; // 引入css

import axios from '@/axios/index'
import VueLazyload from 'vue-lazyload'
// import vue3videoPlay from "vue3-video-play"; // 引入组件
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

import { judgeBtnRole } from '@/utils/tools'
import vue3WaterMarker from "vue3-water-marker";
import { WaterMark } from "@simon_he/vue-watermark";

const app = createApp(App)
app.config.globalProperties.axios = axios
app.config.globalProperties.judgeBtnRole = judgeBtnRole

app.directive('focus', {
  mounted: function (el) {
    el.focus()
    el.click()
  },
})

app.component('WaterMark', WaterMark) 

app
  .use(VueLazyload, {
    loading: require('@/assets/images/default_img.png'),
  })
  .use(router as any)
  .use(store as any)
  .use(Antd)
  .use(ElementPlus)
  .use(VueVideoPlayer)
  .use(vue3WaterMarker)
  .mount('#app')
